import { AxiosError } from 'axios';
import { useI18n } from 'contexts/i18n';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';
import { displayNotification } from 'utils/notification';

export const useDsoRemoveLineItemFromCart = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ServerStateKeysEnum.dsoRemoveLineitemMutation,
    (childLineItemId: number) => {
      return dsoCartService.removeLineItem(childLineItemId);
    },
    {
      onSuccess: data => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
      },
      onError: (err: AxiosError<{ error: string }>) => {
        const errMessage =
          err?.response?.data?.error ?? i18n['Failed to remove item from Cart!'];
        displayNotification(errMessage, 'danger');
      },
    }
  );
};
